import defaultTheme from "tailwindcss/defaultTheme";

import baseConfig from "../tailwind.config";

export const Colors = baseConfig.theme.colors;
export const FontSizes = baseConfig.theme.fontSize;
export const BorderRadius = defaultTheme.borderRadius;
export const theme = { ...defaultTheme, ...baseConfig.theme };
